import { Grid, Box, Typography } from '@mui/material';
import { lightModeCrossPolColor } from '../spectrumChart/utils/colors';
import useGetChartFontSize from './hooks/useGetChartFontSize';
import { getMinMaxMean, getSecondaryDataType } from './utils/dataConverters';
import { Weather } from '../../types/models/Weather';
import { MeasurementData } from '../weather/types';
import useInLightMode from 'hooks/useInLightMode';
import { getLabelForMeasurementType } from '../weather/utils/dataConverters';
import { useAppSelector } from 'app/hooks';
import { HourlyData } from 'types/models/ForecastDto';
import { useWeatherWall } from './api/getWeatherWall';

interface Props {
  convertedWeatherData: (Weather | HourlyData)[];
  isSecondaryData: boolean;
  measurement: MeasurementData;
  wallId?: number;
}

const WeatherChartAnnotations = ({
  convertedWeatherData,
  isSecondaryData,
  measurement,
  wallId,
}: Props) => {
  const { data: wall } = useWeatherWall({ wallId });
  const chartFontSize = useGetChartFontSize(wall);
  const inLightMode = useInLightMode();
  const inImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  const { min, max, mean } = getMinMaxMean(convertedWeatherData, measurement);
  const {
    min: secondaryMin,
    max: secondaryMax,
    mean: secondaryMean,
  } = getMinMaxMean(convertedWeatherData, getSecondaryDataType(measurement));
  return (
    <>
      <Grid item container justifyContent='space-around' alignItems='center'>
        {isSecondaryData && (
          <Grid
            item
            container
            wrap='nowrap'
            justifyContent='center'
            alignItems='center'
            xs
          >
            <Box
              sx={{
                width: '15px',
                height: '15px',
                backgroundColor: inLightMode ? '#009FF9' : 'yellow',
                marginRight: '5px',
              }}
            ></Box>
            <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
              {getLabelForMeasurementType(measurement, inImperial)}
            </Typography>
          </Grid>
        )}
        <Grid item xs container justifyContent='center'>
          <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
            Min: {min}
          </Typography>
        </Grid>
        <Grid item xs container justifyContent='center'>
          <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
            Max: {max}
          </Typography>
        </Grid>
        <Grid item xs container justifyContent='center'>
          <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
            Mean: {mean}
          </Typography>
        </Grid>
      </Grid>
      {isSecondaryData && (
        <Grid item container justifyContent='space-around'>
          <Grid item container alignItems='center' justifyContent='center' xs>
            <Box
              sx={{
                width: '15px',
                height: '15px',
                backgroundColor: inLightMode
                  ? lightModeCrossPolColor
                  : '#009FF9',
                marginRight: '5px',
              }}
            ></Box>
            <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
              {getLabelForMeasurementType(
                getSecondaryDataType(measurement),
                inImperial
              )}
            </Typography>
          </Grid>
          <Grid item xs container justifyContent='center'>
            <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
              Min: {secondaryMin}
            </Typography>
          </Grid>
          <Grid item xs container justifyContent='center'>
            <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
              Max: {secondaryMax}
            </Typography>
          </Grid>
          <Grid item xs container justifyContent='center'>
            <Typography sx={{ fontSize: chartFontSize }} variant='body2'>
              Mean: {secondaryMean}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WeatherChartAnnotations;
